import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import {
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
  TableContainer,
  Text,
  Button,
} from "@chakra-ui/react";
import axios from "axios";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Print_pdf_subject_class = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [subjects, setSubjects] = useState([]); // New state for subject list
  const schoolName = sessionStorage.getItem("school_name");
  const schoolEmail = sessionStorage.getItem("school_email");
  const schoolAddress = sessionStorage.getItem("school_address");
  const schoolImage = sessionStorage.getItem("school_image_url");
  const printRef = useRef();

  useImperativeHandle(ref, () => ({
    handlePrint,
  }));

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();

    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        })
    );

    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const jwtToken = localStorage.getItem("jwtToken");
        const response = await axios.get(
          `${BASE_URL}/admin/subject/list_all_subject_to_class.php`,
          {
            headers: { Authorization: `Bearer ${jwtToken}` },
          }
        );
        setSubjects(response.data.data || []);
        console.log("Subjects data:", response.data.data);
      } catch (error) {
        console.error("Error fetching subject data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div
      ref={printRef}
      style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}
    >
      {/* Header */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "40px",
          borderBottom: "1px solid #e5e5e5",
          paddingBottom: "20px",
          gap: "24px",
        }}
      >
        <img
          src={schoolImage ? `${schoolImage}` : ""}
          alt={`school Logo`}
          style={{
            width: "70px",
            height: "70px",
            objectFit: "contain",
            backgroundColor: "#fff",
            padding: "10px",
          }}
        />

        <div>
          <h1
            style={{
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              fontFamily: "'Times New Roman', serif",
              letterSpacing: "0.5px",
            }}
          >
            {schoolName}
          </h1>
          <h2
            style={{
              margin: "6px 0 0",
              fontSize: "18px",
              fontWeight: "500",
              color: "#666",
              fontFamily: "'Times New Roman', serif",
            }}
          >
            {schoolAddress}
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "#6C757D",
              margin: "6px 0 0",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {schoolEmail}
          </p>
        </div>
      </div>

      {/* Subject List */}
      <div style={{ marginTop: "20px" }}>
        <h3>Subjects List</h3>
        <TableContainer>
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
            style={{
              border: "1px solid #d4c2c2",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <Thead>
              <Tr>
                <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {" "}
                  Class
                </Th>
                <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  Subject Name
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {subjects.map((subject, index) => (
                <Tr key={index}>
                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {subject.class}
                  </Td>
                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {subject.subjects}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
});

export default Print_pdf_subject_class;
